import React, { useState } from "react";
import { productModalType } from "../../features/editAndView/ViewAndEditType";
import { getBlob, updateProduct } from "../../services/userService";
import ViewAndEditModal from "../viewAndEditModal/ViewAndEditModal";
import { ProductDetails, ProductImage, UomMapping } from "./ProductModalState";
import { element, productMetaData } from "./ProductModalTypes";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const ProductModal = ({
  modelData,
  close,
  setGenericMetaData,
  getTableRows,
  additionaCachedData,
  disableEdit 
}: productModalType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "ProductDetails"
  const [activeButton, setActiveButton] = useState(0);

  const [check, setCheck] = useState(false);
  const [element, setElement] = useState<element>({
    blobKey: modelData.blobKey,
    fileName: modelData.fileName,
  });

  const [defaultInputs, setDefaultInputs] =
    useState<productMetaData>(modelData);

  const [editRequestBody, setEditRequestBody] = useState<productMetaData>({
    batchCode: modelData.batchCode,
    skuCode: modelData.skuCode,
    skuName: modelData.skuName,
    brand: modelData.brand,
    category: modelData.category,
    otherUnitToPieceQuantity: modelData.otherUnitToPieceQuantity,
    caseToPieceQuantity: modelData.caseToPieceQuantity,
    blobKey: modelData.blobKey,
    fileName: modelData.fileName,
  });

  const uploadProductData = async (file?: File | null) => {
    try {
      if (!check) {
        close();
        return;
      }
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const blobKey = await getBlob(formData);
        if (blobKey.status !== 200 && blobKey.status !== 201) {
          throw new Error();
        }
        editRequestBody.blobKey = blobKey?.data?.features[0]?.Uri;
        editRequestBody.fileName = blobKey?.data?.features[0]?.name;
      }
      else{
        // if initially there is a image but now user does not want to uplaod image
        if(!element.blobKey){
          editRequestBody.blobKey = "";
          editRequestBody.fileName = "";
        }
      }
      const response = await updateProduct(editRequestBody);
      if (response.status === 200 || response.status === 201) {
        setGenericMetaData(translate(TranslationEnum.common_portal,"Successfully updated the data"), "Success", true);
      } else {
        throw new Error();
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error Ocured while updating the data",
        "Error",
        true
      );
    }
    close();
  };

  const changeModalState = (activeButton: number) => {
    switch (activeButton) {
      case 0:
        return (
          <ProductDetails 
            disableEdit={disableEdit}
            submit={{ check, setCheck }}
            additionalCachedData={additionaCachedData}
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
      case 1:
        return (
          <ProductImage
            submit={{ check, setCheck }}
            resolution={{ height: 500, width: 500 }}
            elementState={{ element, setElement }}
          />
        );
      case 2:
        return (
          <UomMapping 
            disableEdit={disableEdit}
            submit={{ check, setCheck }}
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
      default:
        return (
          <ProductDetails
            disableEdit={disableEdit}
            submit={{ check, setCheck }}
            additionalCachedData={additionaCachedData}
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
    }
  };
  return (
    <ViewAndEditModal
      message={translate(TranslationEnum.common_portal,"Edit a record")}
      closeModal={close}
      updateMethod={async () => {
        await uploadProductData(
          element?.inputRef?.files ? element?.inputRef?.files[0] : null
        );
      }}
      check={check}
    >
      <div className="modal-content">
        <div className="modal-states">
          <button
            onClick={() => {
              setActiveButton(0);
            }}
            className={
              activeButton === 0
                ? "active-model-button model-button"
                : "model-button"
            }
          >
             {translate(TranslationEnum.product_details,"Product Details")}
          </button>
          <button
            onClick={() => {
              setActiveButton(1);
            }}
            className={
              activeButton === 1
                ? "active-model-button model-button"
                : "model-button"
            }
          >
             {translate(TranslationEnum.product_details,"Product Image")}
          </button>
          <button
            onClick={() => {
              setActiveButton(2);
            }}
            className={
              activeButton === 2
                ? "active-model-button model-button"
                : "model-button"
            }
          >
             {translate(TranslationEnum.product_details,"UOM Mapping")}
          </button>
        </div>
        {changeModalState(activeButton)}
      </div>
    </ViewAndEditModal>
  );
};

export default ProductModal;
